import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Login from "./Page/Login/Login";
import Register from "./Page/Register/Register";
import Home from "./Page/Home/Home";
import EstimatePage from "./Page/Estimate/EstimatePage";
import MemberManagement from "./Page/Member/MemberManagement";
import AddSoftware from "./Page/AddSoftware/AddSoftware";
import DocumentPage from "./Page/Document/DocumentPage";
import EditSoftware from "./Page/AddSoftware/EditSoftware";
import EstimateSoftware from "./Page/AddSoftware/EstimateSoftware";
import EstimateResult from "./Page/AddSoftware/EstimateResult";
import SetupParameter from "./Page/SetupParameter/SetupParameter";
import AddUsecase from "./Page/AddSoftware/AddUsecase";
import AddFunction from "./Page/AddSoftware/AddFunction";
import EstimateManhour from "./Page/Estimate/EstimateManhour";
import SummaryCost from "./Page/Estimate/SummaryCost";
import SummaryDuration from "./Page/Estimate/SummaryDuration";
import ApproveEstimate from "./Page/Estimate/ApproveEstimate";
import ProtectedRoute from "./components/protectRoute/ProtectedRoute";
import ForgetPassword from "./Page/Login/ForgetPassword";
import Authentication from "./Page/OTP/Authentication";

function App() {
  return (
    <>
      <Routes>
        {/* ===== Public ===== */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/authentication" element={<Authentication />} />
        {/* ===== Protected ===== */}
        {/* <Route element={<ProtectedRoute />}> */}
          <Route path="/home" element={<Home />} />
          <Route path="/members" element={<MemberManagement />} />
          <Route path="/add" element={<AddSoftware />} />
          <Route path="/document" element={<DocumentPage />} />
          <Route path="/software/edit/:id" element={<EditSoftware />} />
          <Route path="/software/estimate/:id" element={<EstimateSoftware />} />
          <Route path="/software/result/:id" element={<EstimateResult />} />
          <Route path="/software/addusecase/:id" element={<AddUsecase />} />
          <Route path="/software/addfunction/:id" element={<AddFunction />} />
          <Route path="/estimate" element={<EstimatePage />} />
          <Route path="/setupparameter" element={<SetupParameter />} />
          <Route path="/manhours/:id" element={<EstimateManhour />} />
          <Route path="/summarycost/:id" element={<SummaryCost />} />
          <Route path="/summaryduration/:id" element={<SummaryDuration />} />
          <Route path="/approve/:id" element={<ApproveEstimate />} />
        {/* </Route> */}

        {/* ===== Default ===== */}
        <Route path="/" element={<Navigate to="/login" replace />} />
      </Routes>

      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={4000}
        pauseOnHover
        theme="colored"
      />
    </>
  );
}

export default App;
